/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DCFFinancialPeriod } from './DCFFinancialPeriod';
export type ValuationApproachDCF = {
  readonly id?: number;
  dcf_financial_period?: Array<DCFFinancialPeriod>;
  valuation_approach: number;
  terminal_value?: ValuationApproachDCF.terminal_value;
  revenue_gpc_multiple_selection?: ValuationApproachDCF.revenue_gpc_multiple_selection;
  ebitda_gpc_multiple_selection?: ValuationApproachDCF.ebitda_gpc_multiple_selection;
  deleted_dcf_financial_periods?: Array<number>;
  readonly created_at?: string;
  readonly updated_at?: string;
  name: string;
  readonly last_audit_event_id?: string | null;
  is_deleted?: boolean | null;
  readonly deleted_at?: string | null;
  present_value_of_terminal_value?: string | null;
  wacc_cost_of_equity?: string | null;
  wacc_cost_of_debt?: string | null;
  wacc_invested_capital_debt?: string | null;
  wacc_invested_capital_equity?: string | null;
  wacc?: string | null;
  balance_sheet_ltm_cash?: string | null;
  nol_ebit_pre_tax_cut?: string | null;
  nol_ebit_post_tax_cut?: string | null;
  nol_present_value_savings?: string | null;
  long_term_growth_rate?: string | null;
  years_of_high_growth?: string | null;
  high_growth_rate?: string | null;
  revenue_gpc_multiple?: string | null;
  ebitda_gpc_multiple?: string | null;
  market_value?: string | null;
  ebitda_gpc_approach_selection?: number | null;
  revenue_gpc_approach_selection?: number | null;
  ebitda_gpt_approach_selection?: number | null;
  revenue_gpt_approach_selection?: number | null;
};
export namespace ValuationApproachDCF {
  export enum terminal_value {
    PERPETUITY_GROWTH = 'Perpetuity Growth',
    H_MODEL = 'H-Model',
    REVENUE_MULTIPLE = 'Revenue Multiple',
    EBITDA_MULTIPLE = 'EBITDA Multiple',
    REV_EBITDA_MULTIPLE = 'Rev & EBITDA Multiple',
  }
  export enum revenue_gpc_multiple_selection {
    MEAN = 'Mean',
    MEDIAN = 'Median',
    _25TH_PERCENTILE = '25th Percentile',
    _75TH_PERCENTILE = '75th Percentile',
    SELECTED = 'Selected',
    SELECTION_A = 'Selection A',
    SELECTION_B = 'Selection B',
    OTHER = 'Other',
  }
  export enum ebitda_gpc_multiple_selection {
    MEAN = 'Mean',
    MEDIAN = 'Median',
    _25TH_PERCENTILE = '25th Percentile',
    _75TH_PERCENTILE = '75th Percentile',
    SELECTED = 'Selected',
    SELECTION_A = 'Selection A',
    SELECTION_B = 'Selection B',
    OTHER = 'Other',
  }
}

